import { fromEntries } from '../utils/fromEntries';
import { shallowCompareArrays } from '../utils/shallowCompareArrays';
import { createOutlet } from './Outlet';
export function combine(handleMap) {
    var keys = Object.keys(handleMap);
    var outlets = keys.map(function (key) { return handleMap[key]; });
    var last;
    var combinedOutlet = createOutlet({
        getCurrentValue: function () {
            var currentValues = outlets.map(function (outlet) { return outlet.getCurrentValue(); });
            if (!last || !shallowCompareArrays(last.values, currentValues)) {
                last = {
                    values: currentValues,
                    combinedValue: fromEntries(currentValues.map(function (value, i) { return [keys[i], value]; })),
                };
            }
            return last.combinedValue;
        },
        hasCurrentValue: function () { return outlets.every(function (outlet) { return outlet.hasCurrentValue(); }); },
        subscribe: function (callback) {
            var unsubscribes = outlets.map(function (outlet) { return outlet.subscribe(callback); });
            return function () { return unsubscribes.forEach(function (unsubscribe) { return unsubscribe(); }); };
        },
    });
    return combinedOutlet;
}
//# sourceMappingURL=combine.js.map